import { createSelector } from '@ngrx/store';

import {
  isErrorState,
  isLoadingState,
  isResultState,
  selectResultState,
} from '../../@core/fetch-state.utils';
import { selectAppState } from '../app.selectors';

import { QuotesState } from './quotes.state.interface';

export const selectActiveQuotes = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.activeQuotes),
);

export const selectActiveQuotesTotalCount = createSelector(
  selectAppState,
  (state) => state.activeQuotesTotalCount,
);

export const selectActiveQuotesLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.activeQuotes),
);

export const selectActiveQuotesError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.activeQuotes),
);

export const selectArchivedQuotes = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.archivedQuotes),
);

export const selectArchivedQuotesTotalCount = createSelector(
  selectAppState,
  (state) => state.archivedQuotesTotalCount,
);

export const selectArchivedQuotesLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.archivedQuotes),
);

export const selectArchivedQuotesError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.archivedQuotes),
);

export const selectAssignees = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.assignees),
);

export const selectCustomers = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.customers),
);

export const selectStatuses = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.statuses),
);

export const selectShippingMethods = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.shippingMethods),
);

export const selectQuotesShippingMethod = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.quotesShippingMethod),
);

export const selectCANumbers = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.caNumbers),
);

export const selectCANumbersLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.caNumbers),
);

export const selectCANumbersError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.caNumbers),
);

export const selectCaNumbersSuccess = createSelector(selectAppState, (state: QuotesState) =>
  isResultState(state.caNumbers),
);

export const selectSelectedCANumber = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.selectedCANumber),
);

export const selectSelectedCANumberLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.selectedCANumber),
);

export const selectSelectedCANumberError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.selectedCANumber),
);

export const selectSelectedCANumberSuccess = createSelector(selectAppState, (state: QuotesState) =>
  isResultState(state.selectedCANumber),
);

export const selectItemProcesses = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.itemProcesses),
);

export const selectItemProcessesLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.itemProcesses),
);

export const selectItemProcessesError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.itemProcesses),
);

export const selectSelectedItemProcess = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.selectedItemProcess),
);

export const selectSelectedItemProcessLoading = createSelector(
  selectAppState,
  (state: QuotesState) => isLoadingState(state.selectedItemProcess),
);

export const selectSelectedItemProcessError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.selectedItemProcess),
);

export const selectCreatedQuote = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.createdQuote),
);

export const selectCreatedQuoteLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.createdQuote),
);

export const selectCreatedQuoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.createdQuote),
);

export const selectSelectedQuote = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.selectedQuote),
);

export const selectSelectedQuoteLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.selectedQuote),
);

export const selectSelectedQuoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.selectedQuote),
);

export const selectItemProcessesCategories = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.itemProcessesCategories),
);

export const selectItemProcessesCategoriesLoading = createSelector(
  selectAppState,
  (state: QuotesState) => isLoadingState(state.itemProcessesCategories),
);

export const selectItemProcessesCategoriesError = createSelector(
  selectAppState,
  (state: QuotesState) => isErrorState(state.itemProcessesCategories),
);

export const selectSavedNote = createSelector(selectAppState, (state: QuotesState) =>
  selectResultState(state.savedNote),
);

export const selectSavedNoteLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.savedNote),
);

export const selectSavedNoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.savedNote),
);

export const selectExportQuotesBundleLoading = createSelector(
  selectAppState,
  (state: QuotesState) => isLoadingState(state.exportQuotesBundle),
);

export const selectExportQuotesBundleError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.exportQuotesBundle),
);

export const selectArchivedQuoteSuccess = createSelector(selectAppState, (state: QuotesState) =>
  isResultState(state.archivedQuote),
);

export const selectArchivedQuoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.archivedQuote),
);

export const selectUnarchivedQuoteSuccess = createSelector(selectAppState, (state: QuotesState) =>
  isResultState(state.unarchivedQuote),
);

export const selectUnarchivedQuoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.unarchivedQuote),
);

export const selectDeletedQuoteSuccess = createSelector(selectAppState, (state: QuotesState) =>
  isResultState(state.deletedQuote),
);

export const selectDeletedQuoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.deletedQuote),
);

export const selectUpdatedQuoteLoading = createSelector(selectAppState, (state: QuotesState) =>
  isLoadingState(state.updatedQuote),
);

export const selectUpdatedQuoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.updatedQuote),
);

export const selectDuplicatedQuoteSuccess = createSelector(selectAppState, (state: QuotesState) =>
  isResultState(state.duplicatedQuote),
);

export const selectDuplicatedQuoteError = createSelector(selectAppState, (state: QuotesState) =>
  isErrorState(state.duplicatedQuote),
);
